export default __webpack_public_path__ + "static/media/logo_text--white.f1b256a0.svg";